// Shared RBAC module registry (mirrors backend rbac.py MODULES/LEVELS).
export const MODULES = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'tenders', label: 'Tenders / Estimation' },
  { key: 'rate_masters', label: 'Rate Masters' },
  { key: 'costing', label: 'Costing / Cost Centre' },
  { key: 'project', label: 'Project / Site Execution' },
  { key: 'analytics', label: 'Win-Loss Analytics' },
  { key: 'reports', label: 'Reports' },
  { key: 'users', label: 'User & Access Management' },
  { key: 'settings', label: 'Settings' },
];

export const LEVELS = ['deny', 'read', 'readwrite', 'approve'];
export const LEVEL_RANK = { deny: 0, read: 1, readwrite: 2, approve: 3 };
export const LEVEL_LABEL = {
  deny: 'No access',
  read: 'View only',
  readwrite: 'View & edit',
  approve: 'View, edit & approve',
};
export const SCOPE_LABEL = { own: 'Own records only', all: 'All records' };

export function levelAllows(level, required = 'read') {
  return (LEVEL_RANK[level] || 0) >= (LEVEL_RANK[required] || 0);
}

// Route -> module key, used for nav filtering and route guards.
export const ROUTE_MODULE = {
  '/': 'dashboard',
  '/projects': 'tenders',
  '/costing': 'costing',
  '/budget': 'project',
  '/masters': 'rate_masters',
  '/users': 'users',
  '/settings': 'settings',
};
